module.exports = __webpack_public_path__ + "static/media/platform-step3-desktop.d95014b5.png";